<template>
  <div>
    <Header></Header>
    <main id="content" role="main">
      <!-- Content Section -->
      <div class="container space-3">
        <div class="w-lg-85 mx-lg-auto">
          <!-- Alert -->
          <div class="alert alert-primary media mb-5 mb-md-7" role="alert">
            <i class="fas fa-exclamation-circle mt-1 mr-4"></i>
            <div class="media-body">
              <h4 class="alert-heading">产品更新日志</h4>
              <hr />
              <p
                class="text-inherit mb-0"
               
              >{{content}}</p>
            </div>
          </div>
          <!-- End Alert -->

          <!-- Timeline -->
          <ul class="step" >
            <!-- Timeline Item -->
            <!-- 以前获取历程的方式 -->
            <!-- <li class="step-item" v-for="item in colNum" :key="item.columnId">
              <div class="step-content-wrapper">
                <span class="step-icon step-icon-sm step-icon-soft-primary"
                  ><i class="far fa-calendar-alt"></i
                ></span>
                <div class="step-content">
                  <span class="timeline-heading text-dark">{{ item.subtitle }}</span>
                  <h4 class="h3">{{ item.title }}</h4>
                  <div class="mb-4">
                    <p class="mb-2" v-html="item.content.content"></p>
                  </div>
                </div>
              </div>
            </li> -->
            <!-- End Timeline Item -->
            <!-- Timeline Item -->
            <!-- 以前获取历程的方式 -->
            <li class="step-item" v-for="item in contentNum" :key="item.contentId">
              <div class="step-content-wrapper">
                <span class="step-icon step-icon-sm step-icon-soft-primary"
                  ><i class="far fa-calendar-alt"></i
                ></span>
                <div class="step-content">
                  <span class="timeline-heading text-dark">{{getTime(item.releaseTime) }}</span>
                  <h4 class="h3">{{ item.title }}</h4>
                  <div class="mb-4">
                    <p class="mb-2" v-html="item.content"></p>
                  </div>
                </div>
              </div>
            </li>
            <!-- End Timeline Item -->
          </ul>
          <!-- End Timeline -->
        </div>
      </div>
      <!-- End Content Section -->
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/vendor/jquery/dist/jquery.min.js"; //1
import "@/assets/vendor/jquery-migrate/dist/jquery-migrate.min.js"; //2

import "@/assets/vendor/font-awesome/css/all.min.css"; //5
import "@/assets/css/theme.css"; //6
import AOS from "aos";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; //3
import "@/assets/js/hs.core.js"; //4
import Header from "@/components/header";
import Footer from "@/components/footer";
import moment from 'moment';
import { getsy, getsycolumn, getsyres,getProductInfo } from "../request/index";
export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      devtitle: "",
      devcont: "",
      v1cont: "",
      colNum:[],
      contentNum:[],
      devloplist:{},
      show:false,
      content:null,
    }
  },
  created() {
    this.getFirst()
    getProductInfo({type:2}).then(res=>{
      this.content = res.data.content[0].detail
    })
  },
  methods: {
    // 获取当前栏目
    getFirst() {
      getsycolumn(0).then(res => {
        let arr = res.data;
        for (let i = 0; i < arr.length; i++){
          if (arr[i].type == "产品更新") {
            getsycolumn(arr[i].columnId).then(res => {
              let arr1 = res.data
              let ar1 = []
              for (let i = 0; i < arr1.length; i++) {
                if (arr1[i].type == "DEVS") {
                  this.devtitle = arr1[i].title;
                  getsy(arr1[i].columnId).then(res => {
                    this.devcont = res.data.content
                  })
                }else{
                  ar1.push(arr1[i])
                }
                if(arr1[i].type == "发展历程"){
                  this.getContentTime(arr1[i].columnId)
                }
              }
              // 以前获取历程的方式
              // ar1.forEach(ts => {this.getContent(ts,ts.columnId)})
            })
          }
        }
      })
    },
    
    // 获取内容
    getContent(obj,id) {
      this.show =false
      getsy(id).then(res=>{
        obj.content = res.data.content[0]
        this.colNum.push(obj)
        this.colNum = this.colNum.sort((a,b)=>{return b.type-a.type})
        console.log(this.colNum.length)
      })
    },
    // 获取内容
    getContentTime(id) {
      this.show =false
      getsy(id,{page:0,size:1000}).then(res=>{
        console.log(128,res)
        if(res.data.content.length>0){
          this.contentNum = res.data.content.sort((a,b)=>{return b.createTime - a.createTime})
        }
      })
    },
    // 获取内容资源资源
    getSource(id){
      getsyres(id).then(res=>{
        let arr = res.data
        if(arr && arr.length>0){
          arr.forEach(hs=>{this.imglist[hs.keystring] = hs.fileId})
        }
      })
    },
    // 时间转换
    getTime(val){
        return moment(val).format('YYYY年MM月DD日')
    }
  },
  mounted() {
    // window.addEventListener("scroll", this.handleScroll);
    $(document).ready(function () {
      console.log("aaa");
      //   console.log("ccccc",HSHeader)
      //   var header = new HSHeader($("#header")).init();
      console.log("bbb");

      // initialization of mega menu
      var megaMenu = new HSMegaMenu($(".js-mega-menu"), {
        desktop: {
          position: "left",
        },
      }).init();

      // initialization of unfold
      var unfold = new HSUnfold(".js-hs-unfold-invoker").init();

      // initialization of fancybox
      $(".js-fancybox").each(function () {
        var fancybox = $.HSCore.components.HSFancyBox.init($(this));
      });

      // initialization of circles
      $(".js-circle").each(function () {
        var circle = $.HSCore.components.HSCircles.init($(this));
      });

      //initialization of aos
      AOS.init({
        duration: 650,
        once: true,
      });
      // if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) document.write('<script src="@/assets/vendor/polifills.js"><\/script>');
      // initialization of go to
      $(".js-go-to").each(function () {
        var goTo = new HSGoTo($(this)).init();
      });
      $(".js-counter").each(function () {
        var counter = new HSCounter($(this)).init();
      });
    });
  },
};
</script>

<style scoped>
.space-3,
.space-top-3 {
  padding-top: 30px;
}
.alert-primary {
  color: #fff;
  background-color: #377dff;
  border-color: #377dff;
}
.alert-primary hr {
  border-top-color: #1e6cff;
}
.media-body h4 {
  font-size: 1.125rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.step-content span {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
}
.timeline-heading {
  color: #1e2022 !important;
}
.step-content h4 {
  margin-bottom: 0.5rem;
  font-weight: 600;
  font-size: 1.3125rem;
  line-height: 1.4;
}
.step-content .mb-4 {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
}
</style>


// WEBPACK FOOTER //
// src/view/newup.vue